// Quarters are stored per user in Supabase (user_data, data_type 'spain_plan').
export const PLAN_QUARTERS = []
